/**
 * dev(연동 시험) 빌드.
 *
 * Pay Vcat TCP 연동을 클라이언트 소장과 시험하기 위한 별도 환경이다. 운영(`environment.ts`)은
 * 대표님이 검수 중이라 시험으로 건드릴 수 없어서 프론트·API·DB를 한 벌 더 두었다.
 *
 *   프론트  https://payfms-dev.web.app      (Firebase Hosting 사이트 `payfms-dev`)
 *   API     https://api-dev.payfms.dminsnetwork.com  (VM `paytms-dev`)
 *   DB      paytms_dev                     (운영과 같은 Cloud SQL 인스턴스의 별도 DB)
 *
 * 운영과 갈리는 것은 **주소뿐**이고 코드는 같은 것을 쓴다. 빌드는
 * `npm run build:admin:dev`, 배포는 `firebase deploy --only hosting:dev`.
 * 배포 대상을 반드시 명시한다 — `--only hosting`만 쓰면 prod까지 함께 나간다.
 *
 * 이 주소로 로그인이 되려면 dev 서버의 `ADMIN_ORIGIN`에 `https://payfms-dev.web.app`이
 * 들어 있어야 한다(CORS). 후행 슬래시를 붙이면 서버가 기동을 거부한다.
 * 값은 `deploy/env/dev.env.example` 참고.
 *
 * ⚠ 운영 도메인을 갈아탈 때의 4단계 절차는 `environment.ts` 주석에 있다. dev도 주소를
 * 바꾸게 되면 같은 순서를 따른다 — 서버 `ADMIN_ORIGIN`에 새 오리진 추가 → 프론트 배포 →
 * 확인 → 옛 오리진 제거.
 */
export const environment = {
  apiBaseUrl: 'https://api.pms-dev.paymentkorea.com', // 2026-09-23 클라이언트 도메인 (옛 api-dev.payfms.dminsnetwork.com도 서버는 그대로 받는다)
  /** 공용 UI 쇼케이스(/styleguide) — 검수·리뷰용이라 dev에서만 연다 */
  styleguideEnabled: true,
} as const;
